import React, { useState } from 'react';
import { Container, Box, useTheme } from '@mui/material';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import PasswordResetForm from './PasswordResetForm';

const AuthPage = () => {
  const [currentForm, setCurrentForm] = useState('login'); // 'login', 'register', 'reset'

  const theme = useTheme();

  const renderForm = () => {
    switch (currentForm) {
      case 'register':
        return (
          <RegisterForm 
            onSwitchToLogin={() => setCurrentForm('login')}
          />
        );
      case 'reset':
        return (
          <PasswordResetForm 
            onSwitchToLogin={() => setCurrentForm('login')}
          />
        );
      default:
        return (
          <LoginForm 
            onSwitchToRegister={() => setCurrentForm('register')}
            onSwitchToReset={() => setCurrentForm('reset')}
          />
        );
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: theme.palette.mode === 'light' ? '#f1f5f9' : '#0b0f19',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ animation: 'fadeIn 0.6s ease-out' }}>
          {renderForm()}
        </Box>
      </Container>
    </Box>
  );
};

export default AuthPage;
